async function obtainStorageAccess() {
  try {
    await document.requestStorageAccess();
    parent.postMessage({ topic: 'storage-access-granted' }, '*');
  } catch (err) {
    parent.postMessage({ topic: 'storage-access-denied' }, '*');
  }
}

export function createRequestStorageAccessButton() {
  const button = document.createElement('button');
  button.title = 'request storage access';
  button.style.width = '100%';
  button.style.height = '100%';

  button.addEventListener('click', async (event) => {
    event.preventDefault();
    await obtainStorageAccess();
  });

  const div = document.createElement('div');
  div.style.backgroundImage = "url('/signin.svg')";
  div.style.width = '1rem';
  div.style.height = '1rem';
  div.style.backgroundSize = 'contain';
  div.style.backgroundRepeat = 'no-repeat';
  button.appendChild(div);

  document.body.appendChild(button);
}
